import {
  useGetLSPSStateQuery,
  useGetMicroServiceMonitoringGraphDataQuery,
  useGetMicroServiceMonitoringForcastQuery,
  useGetTargetDataNowQuery,
} from "../operatorDashboardAPISlice";

export default function useDashboardGraphData() {
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const request = {
    queryParams: { startDate: null, endDate: null, userTimezone },
  };

  const { data: lspsState, isLoading: l1, isError: e1 } = useGetLSPSStateQuery(null);
  const { data: microServiceGraphData, isLoading: l2, isError: e2 } =
    useGetMicroServiceMonitoringGraphDataQuery(request);
  const { data: microserviceForcastState, isLoading: l3, isError: e3 } =
    useGetMicroServiceMonitoringForcastQuery(null);
  const { data: targetDataNow, isLoading: l4, isError: e4 } =
    useGetTargetDataNowQuery(null);

  return {
    isLoading: l1 || l2 || l3 || l4,
    isError: e1 || e2 || e3 || e4,
    userTimezone,
    microServiceGraphData: microServiceGraphData || [],
    lspsState,
    microserviceForcastState: microserviceForcastState || [],
    targetDataNow,
  };
}
